<template>
  <div class="register-view" v-if="patient.id">
    <div class="view-panel view-panel1" v-if="!isPad || (patient.status === '1' || patient.status === '3')"
      :class="isPad ? 'view-panel-pad' : ''">
      <patient-info-card :patient="patient" :is-pad="isPad"></patient-info-card>
      <a-row class="info-row">
        <a-col :span="20" class="center-panel">
          <a-button style="width: 50%" type="primary" :size="isPad ? 'small' : 'default'" @click="handleView"> 详细资料
          </a-button>
        </a-col>
        <!-- <a-col :span="12" class="center-panel">
          <a-dropdown>
            <a-menu slot="overlay" @click="handleMenuClick">

              <a-menu-item key="6" v-if="patient.status === '4'"> 恢复随访</a-menu-item>
              <template v-else-if="patient.status !== '1'">
                <a-menu-item key="7" v-has="'patient:period:add'" v-if="patient.status === '2'"> 添加随访周期</a-menu-item>
                <a-menu-item key="1" v-has="'patient:editVisitDate'"> 修改访视日期</a-menu-item> -->
                <!--<a-menu-item key="2" v-has="'export:CRFdata'"> 导出表单</a-menu-item>-->
                <!-- <a-menu-item key="3" v-has="'patient:end'"> 终止筛选</a-menu-item>
              </template>
              <a-menu-item key="4" v-if="patient.status !== '4'" v-has="'patient:register'"> 终止随访</a-menu-item>
              <a-menu-item key="5" v-has="'patient:delete'"> 删除病历</a-menu-item>
            </a-menu>
            <a-button style="width: 95%" :size="isPad ? 'small' : 'default'" type="primary"> 功能栏 <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </a-col> -->
      </a-row>
      <div class="info-row2 ">
        <label class="info-row"> 随访进度：</label>
        <status-tag :status="patient.status"></status-tag>
      </div>
      <div class="info-row ">
        表单进度：<label class="value-info">{{ patientPeriodInfo.formSubmitCount || 0 }}/{{ patientPeriodInfo.formCount ||
          0 }}</label>
      </div>
      <div style="margin-right: 10px">
        <a-progress :percent="formProgress" />
      </div>
      <a-row class="info-row ">
        <a-col :span="12" class="center-panel ">
          <div>
            随访周期进度
          </div>
          <div class="value-info">
            {{ patientPeriodInfo.periodEndCount || 0 }}/{{ patientPeriodInfo.periodCount || 0 }}
          </div>
        </a-col>
        <a-col :span="12" class="center-panel ">
          <div>
            可随访表单数
          </div>
          <div class="value-info">
            {{ patientPeriodInfo.formDoingCount || 0 }}
          </div>
        </a-col>
      </a-row>
      <div class="filtrate-fail" v-if="patient.status === '4' && endPeriodList.length > 0">
        <div class="fail-title">
          <a-icon type="info-circle" style="color: red" />该病例目前【终止随访】
        </div>
        <div class="fail-info">
          终止日期：{{ endPeriodList[0].createTime }}
        </div>
        <div class="fail-info">
          终止操作人：{{ endPeriodList[0].createName }}
        </div>
        <div class="fail-info">
          终止节点：{{ endPeriodList[0].periodType === '1' ? '基线' : '随访周期' }}
        </div>
        <div class="fail-info">
          终止原因：
        </div>
        <div v-for="(item, index) in endPeriodList" :key="index">
          <template>
            <div class="fail-info" style="margin-left: 34px">
              {{ item.typeText }}
            </div>
            <div class="fail-info" style="margin-left: 50px;">
              {{ item.description }}
            </div>
          </template>
        </div>
      </div>
      <!-- <div class="info-row ">
        分组信息
      </div>
      <div class="center-panel value-info">
        {{ patient.groupName || '-' }}
      </div> -->
      <!-- <div class="info-row info-row-border" style="height: 30px">
        <div style="float: center;align-items: center;">
          研究信息
        </div>
        <div style="float: right" v-has="'patient:updateUserId'">
          <a-button type="primary" size="small" shape="circle" icon="edit" @click="changeCenterInfo" />
          <a-button type="primary" style="margin-left: 10px" size="small" shape="circle" icon="clock-circle"
            @click="changeHistory" />
        </div>
      </div> -->
      <div class="center-panel info-row2">
        研究中心
      </div>
      <div class="center-panel value-info">
        {{ patient.centerName }}
      </div>
      <div class="center-panel info-row2">
        研究员
      </div>
      <div class="center-panel value-info research-info-bar">
  <div class="research-title"> {{ patient.personName }}</div>
  <div class="research-actions" v-has="'patient:updateUserId'">
    <a-button type="primary" size="small" shape="circle" icon="edit" @click="changeCenterInfo" />
    <a-button type="primary" style="margin-left: 10px" size="small" shape="circle" icon="clock-circle" @click="changeHistory" />
  </div>
</div>
      <div class="center-panel info-row2">
        注册日期
      </div>
      <div class="center-panel value-info">
        {{ patient.createTime }}
      </div>
      <div class="center-panel info-row2">
        通过筛选日期
      </div>
      <div class="center-panel value-info">
        {{ patient.passDate || '-' }}
      </div>
    </div>
    <div class="view-panel view-panel2"
      :class="isPad ? 'view-panel-pad ' + (patient.status !== '1' && patient.status !== '3' ? 'view-panel2-pad' : '') : ''">
      <filtrate-info v-if="patient.status === '1' || patient.status === '3'" :patient="patient"
        @opHandle="loadData"></filtrate-info>
      <follow-period ref="period" v-else :patient="patient" :projectPeriod="projectPeriod" :loadPatient="loadPatient" @currentPeriodId="currentPeriodId">
        <span slot="btn-left">
          <template v-if="wechat === '1'">
            <a-button type="primary" style="margin-left: 20px" v-if="!patient.wechatId"
              @click="wechatBinding">微信绑定</a-button>
            <a-dropdown v-else>
              <a-menu slot="overlay" @click="handleWechatMenuClick">
                <a-menu-item key="1"> 微信推送</a-menu-item>
                <a-menu-item key="2"> 取消推送</a-menu-item>
                <a-menu-item key="3"> 解除绑定</a-menu-item>
              </a-menu>
              <a-button style="width: 150px;margin-left: 20px" :size="isPad ? 'small' : 'default'" type="primary"> 微信操作
                <a-icon type="down" /> </a-button>              
            </a-dropdown>  
            <a-button type="primary" v-if="patient.wechatId" style="width: 150px; margin-left: 20px" v-has="'patient:wechatPush'" @click="wechatPush">微信推文</a-button>          
          </template>          
        </span>
        <span slot="btn">
          <a-dropdown>
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item key="6" v-if="patient.status === '4'"> 恢复随访</a-menu-item>
              <template v-else-if="patient.status !== '1'">
                <a-menu-item key="7" v-has="'patient:period:add'" v-if="patient.status === '2'"> 添加随访周期</a-menu-item>
                <a-menu-item key="1" v-has="'patient:editVisitDate'"> 修改访视日期</a-menu-item>
                <a-menu-item key="8" v-has="'patient:periodform:edit'"> 添加表单</a-menu-item>
                <!--<a-menu-item key="2" v-has="'export:CRFdata'"> 导出表单</a-menu-item>-->
                <a-menu-item key="3" v-has="'patient:end'"> 终止筛选</a-menu-item>
              </template>
              <a-menu-item key="4" v-if="patient.status !== '4'" v-has="'patient:register'"> 终止随访</a-menu-item>
              <a-menu-item key="5" v-has="'patient:delete'"> 删除病历</a-menu-item>
              <a-menu-item key="9" v-if="reporting==='1'" v-has="'patient:base:report'"> 查看报告</a-menu-item>
              <a-menu-item key="11"  v-has="'patient:base:rctfilter'" v-if="patient.rctStatus!=null&&patient.rctStatus>0"> RCT入组</a-menu-item>
              <a-menu-item key="12"  v-has="'patient:base:rctinterfere'" v-if="patient.rctStatus!=null&&patient.rctStatus=='2'"> RCT干预</a-menu-item>
            </a-menu>
            <a-button style="width: 150px;margin-left: 20px" :size="isPad ? 'small' : 'default'" type="primary"> 功能栏
              <a-icon type="down" /> </a-button>
          </a-dropdown>
        </span>
      </follow-period>
    </div>
    <patient-edit ref="patient-edit" :width="isPad ? '100%' : '60%'" :fieldList="fieldList"></patient-edit>
    <a-modal title="删除" :width="800" :visible="deleteView" :confirmLoading="loading" @ok="handleDeleteOk"
      @cancel="deleteView = false">
      <a-textarea :rows="4" placeholder="请输入删除原因." v-model="patient.delReason" />

    </a-modal>

    <a-modal title="终止随访" :width="1000" :visible="endPeriodVisible" :confirmLoading="loading" @ok="handleEndPeriodOk"
      @cancel="endPeriodVisible = false">
      <div v-for="(item, index) in endPeriodForm.list" :key="index" style="margin-bottom: 20px">
        <div style="margin-bottom: 10px">
          <a-checkbox :checked="item.checked" @change="checkBoxChange($event, item)">
            {{ item.typeText }}
          </a-checkbox>
        </div>
        <div style="margin-left: 30px" v-if="item.checked">
          <template v-if="item.type === '1'">
            <div style="margin-bottom: 10px">
              死亡时间：<a-date-picker value-format='YYYY-MM-DD' style="width: 700px" placeholder="非必填"
                v-model="item.deathDate" />
            </div>
            <div style="margin-bottom: 10px">
              死亡原因：<a-textarea :rows="1" placeholder="非必填" style="width: 700px" v-model="item.deathCause" />
            </div>
          </template>
          <div style="margin-bottom: 10px" v-if="item.remarkFlag != '0'">
            补充说明：<a-textarea :rows="1" placeholder="非必填" style="width: 700px" v-model="item.description" />
          </div>
        </div>
      </div>
      <div style="margin-top: 20px;text-align: center">
        <a-checkbox :checked="endPeriodForm.checked" @change="checkBoxChange($event, endPeriodForm)">
          自动操作后续失访提交
        </a-checkbox>
      </div>
    </a-modal>

    <a-modal title="RCT入组筛选" :width="1000" :visible="rctFilterVisible" :confirmLoading="loading" @ok="handleRctFilterOk"
      @cancel="rctFilterVisible = false">
      <div v-for="(item, index) in rctFilterForm" :key="index" style="margin-bottom: 20px" >
        <div style="margin-bottom: 10px">
          <a-checkbox :checked="item.checked" @change="checkBoxChange($event, item)" :disabled="patientRCTConfig.rctCheck.isRct">
            {{ item.typeText }}
          </a-checkbox>
        </div>
      </div>
    </a-modal>

    <a-modal title="RCT干预" :width="1000" :visible="rctInterfereVisible" :confirmLoading="loading" @ok="handleRctInterfereOk"
      @cancel="rctInterfereVisible = false">
      <div  style="margin-bottom: 20px" >
        <a-checkbox  v-if="patientRCTConfig.rctGroup==='A组'" :checked="true">
         <strong> A组：0.4 mg/kg艾司氯胺酮稀释于20ml生理盐水（艾司氯胺酮组）</strong>
          </a-checkbox>
          <a-checkbox  v-if="patientRCTConfig.rctGroup==='B组'" :checked="true">
            <strong> B组：0.9% 20ml生理盐水.将以30毫升/小时的速度静脉注射40分钟 </strong>
          </a-checkbox>
      </div>
      <div  style="margin-bottom: 20px" >
        <!-- <a-checkbox style="margin-bottom: 10px">
         <strong>干预完成</strong>
          </a-checkbox>
          <br>
          <a-checkbox style="margin-bottom: 10px">
            <strong>干预未完成，请备注原因： </strong>
           
          </a-checkbox> -->
          <a-radio-group v-model="patientRCTConfig.rctInterfere.status" style="margin-bottom: 10px">
            <a-radio value="0">
              <strong>干预完成</strong>
            </a-radio>
            <br>
            <a-radio value="1">
              <strong>干预未完成，请备注原因：</strong>
            </a-radio>
          </a-radio-group>
          <br>
          <a-textarea v-if="patientRCTConfig.rctInterfere.status==='1'" v-model="patientRCTConfig.rctInterfere.remark" :rows="2" placeholder="非必填" style="width: 700px"  />
      </div>
     
    </a-modal>


    <a-modal title="查看报告"  :width="1000" :visible="reportVisible" :confirmLoading="loading" @ok="handleReportingOk"
      @cancel="reportVisible = false">
      <template>
        <div style="text-align: right; margin-bottom: 10px;"> <a-button style="width: 100px;margin-right: 20px;"
            @click="generatePDF">下载报告</a-button></div>

        <!-- <div class="report-container">
          <div class="report-header">
            <h1 class="report-title">心理评估报告——辅助量表</h1>
          </div> -->
        <div class="report-body">
          <div id="table-title" style="font-size: 20px; font-weight: bold; text-align: center; margin-bottom: 10px;">
            {{reportData.reportName}}
          </div>
          <table class="report-table" id="table-content" :border="1">
            <tr>
              <td class="report-cell">住院（门诊）号：{{ reportData.patientNum }}</td>
              <td class="report-cell">测试时间：{{ reportData.time }}</td>
            </tr>
            <tr>
              <td class="report-cell">姓名：{{ reportData.name }}</td>
              <td class="report-cell">年龄：{{ reportData.age }}</td>
            </tr>
            <tr>
              <td class="report-cell">性别：{{ reportData.sex }}</td>
              <td class="report-cell"></td>
            </tr>
            <tr v-for="(row, rowIndex) in data" :key="rowIndex">
              <td class="report-cell" v-for="(group, colIndex) in row" :key="colIndex">
                <strong> {{ group.formName }}</strong>
                <br>
                测试得分 总分：{{ group.resultScore }}
                <div v-for="(item, itemIndex) in group.formItems" :key="itemIndex">
                  {{ item.resultName }}:{{ item.resultScore }}
                </div>
                <br>
                测试结论 : {{ group.resultRemark }}
              </td>
            </tr>
          </table>
          <div id="table-end" style="font-size: 10px; font-weight: bold; text-align: left; margin-bottom: 10px;">
            注意以上结果只反映了您近期的状态，并不等同于临床诊断。如确感自身状态不佳，且已经持续一段时间，依靠自身力量无法调节，或者感受能力有变差的趋势，建议您寻求心理健康专业人士的帮助，进行复查和进一步评估，他们可以提供专业的指导和支持。
          </div>
        </div>
        <span></span>
      </template>
    </a-modal>

    <a-modal :title="`修改访视日期`" :width="800" :visible="baseDateView" :confirmLoading="loading"
      @ok="handleUpdateBaseDateOk" @cancel="baseDateView = false">
      <a-select v-model="followPeriodId" placeholder="请选择访视周期" style='min-width: 200px' allow-clear showSearch :filterOption="filterOptionTip"
        @change="followPeriodChange">
        <a-select-option :value="item.id" v-for="(item, key) in followList" :key="key">
          <a-tooltip :title="item.groupName ? item.groupName + (item.groupStatus=='2'?'(终止)':'') + ' ' + item.name : item.name">
            {{ item.groupName ? item.groupName + (item.groupStatus=='2'?'(终止)':'') + " " + item.name : item.name }}
          </a-tooltip>
        </a-select-option>
      </a-select>
      <!-- {{projectPeriod.baseName||'基线'}}-->访视日期：<a-date-picker value-format='YYYY-MM-DD'
        v-model="followPeriodDate" />
      <!-- <a-divider />
      同步周期日期：
      <a-checkbox-group v-model="followPeriodIds">
        <a-checkbox v-for="(item, key) in followList" :key="key" :value="item.id">{{ item.name }}</a-checkbox>
      </a-checkbox-group> -->
    </a-modal>
    <a-modal title="变更研究者" :width="800" :visible="changeView" :confirmLoading="loading" @ok="handleChangeCenterOk"
      @cancel="changeView = false">
      <a-form-model layout="horizontal" :model="changeCenterInfoModel" :label-col="labelCol" :wrapper-col="wrapperCol"
        ref="form">
        <a-form-model-item label="研究中心">
          <a-select v-model="changeCenterInfoModel.centerId" placeholder="请选择">
            <a-select-option v-for="item in centerList" :key="item.center.id" :value="item.center.id">
              {{ item.center.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="研究人员">
          <a-select v-model="changeCenterInfoModel.personId" placeholder="请选择">
            <a-select-option v-for="item in userList" :key="item.id" :value="item.userId">
              {{ item.realname }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>


    </a-modal>
    <a-modal title="变更研究者" :width="800" :visible="changeHistoryView" :confirmLoading="loading" :footer="null"
      @cancel="changeHistoryView = false">
      <a-table size="middle" rowKey="id" :columns="historyColumn" :pagination="false" :dataSource="historyList"
        :loading="loading">
      </a-table>
    </a-modal>
    <a-modal title="绑定微信" :width="400" :visible="qrCodeVisible" :confirmLoading="loading" :footer="null"
      @cancel="qrCodeCancel">
      <div>
        <a-alert show-icon message="请先绑定微信后，再发起微信推送" type="info" />
      </div>
      <div style="margin-top: 10px">
        请打开微信【扫一扫】，关注公众号后自动绑定
      </div>
      <div style="text-align: center">
        <img v-if="qrCodeUrl" :src="qrCodeUrl" style="width:200px;height:200%" />

      </div>
      <div style="text-align: center">
        <a-button icon="reload" @click="reloadQrCode">刷新二维码</a-button>
      </div>
      <div style="text-align: right;margin-top: 20px">
        <a-button type="primary" @click="handleQrCodeClose">确定</a-button>
      </div>
    </a-modal>
    <a-modal title="表单列表" :width="500" :visible="formPushVisible || formUnPushVisible" :confirmLoading="loading"
      :footer="null" @cancel="formPushCancel">
      <div>
        <a-alert show-icon :message="`请确认需要${formPushVisible ? '推送' : '取消推送'}的表单。`" type="info" />
      </div>
      <div style="margin-top: 10px" v-for="(item, index) in selectRowsInfo.selectionRows" :key="index">
        {{ index + 1 }}、{{ item.name }}
      </div>

      <div style="text-align: right;margin-top: 20px">
        <a-button type="primary" @click="formPushVisible ? pushWechatSubmit() : unPushWechatSubmit()">确定</a-button>
      </div>
    </a-modal>
    <fail-filtrate v-if="patient.status !== '1'" :patient="patient" @opHandle="loadData"
      ref="failFiltrateModal"></fail-filtrate>
    <patient-period-form-add ref="addPeriodFormModal" :patient="patient" @close="modelClose"></patient-period-form-add>
  </div>
  <div v-else style="margin-top: 50px">
    <a-empty>
      <span slot="description">
        {{ emptyDescription }}
      </span>
    </a-empty>
  </div>
</template>

<script>
import FiltrateInfo from './components/FiltrateInfo'
import FollowPeriod from './components/FollowPeriod'
import PatientInfoCard from './components/PatientInfoCard'
import { getAction, deleteAction, postAction } from '@/api/manage'
import PatientEdit from './components/PatientEdit'
import StatusTag from './components/StatusTag'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import FailFiltrate from './components/FailFiltrate'
import { CACHE_PROJECT_ID } from '@/constants/project'
import PatientPeriodFormAdd from './components/followperiod/PatientPeriodFormAdd'
import Vue from 'vue'
import html2pdf from 'html2pdf.js';

export default {
  name: 'RegisterView',
  components: { FailFiltrate, ATextarea, StatusTag, PatientEdit, PatientInfoCard, FollowPeriod, FiltrateInfo, PatientPeriodFormAdd,},
  inject: ['closeCurrent'],
  data() {
    return {
      wechat: '0',
      reporting:'0',
      reportData: {},
      data: [],
      projectId: Vue.ls.get(CACHE_PROJECT_ID),
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      fieldList: [],
      patient: {},
      deleteView: false,
      loading: false,
      emptyDescription: '正在加载中',
      changeView: false,
      changeHistoryView: false,
      centerList: [],
      userList: [],
      changeCenterInfoModel: {},
      historyList: [],
      historyColumn: [{
        title: '操作时间',
        width: 200,
        dataIndex: 'createTime',
      }, {
        title: '描述',
        dataIndex: 'description',
      }],
      baseDateView: false,
      endPeriodVisible: false,
      reportVisible: false,
      rctFilterVisible:false,
      rctInterfereVisible:false,
      patientPeriodInfo: {

      },
      rctInterfereForm:[{}],
      patientRCTConfig:{rctCheck:{},rctGroup:'',rctInterfere:{status:'1',remark:''}},
      rctFilterForm: [{
          type: '1',
          typeText: '1.	存在氯胺酮或艾司氯胺酮相对禁忌症的患者，包括：未规律控制的高血压3级（指收缩压≥180 mmHg和/或舒张压≥110 mmHg）、冠心病（诊断为冠状动脉粥样硬化性心脏病或者冠脉CTA显示冠状动脉粥样硬化）、重度或极重度心功能不全（NYHA分级III级或IV级）、肺动脉高压（肺动脉收缩压大于或等于 25 mmHg，或肺动脉平均压力大于或等于 20 mmHg）、颅眼高压、甲状腺功能亢进、嗜铬细胞瘤；',
          checked: false,
        },
        {
          type: '2',
          typeText: '2.	异常的肝功能和肾功能，异常肝功能定义为天冬氨酸氨基转移酶（AST）和/或丙氨酸氨基转移酶（ALT）水平超过正常上限的 1.5 倍，以及异常肾功能定义为血清肌酐（Cr）≥正常上限（ULN）的 1.5 倍；',
          checked: false,
        },
        {
          type: '3',
          typeText: '3.	有精神病或双相情感障碍病史，复发性抑郁症，筛查前两周内接受抗抑郁药物治疗；',
          checked: false,
        },
        {
          type: '4',
          typeText: '4.	阿片类药物滥用和酗酒者；',
          checked: false,
        },
        {
          type: '5',
          typeText: '5.	对本研究所用药物有过敏反应史的患者；',
          checked: false,
        },
        {
          type: '6',
          typeText: '6.	沟通困难无法配合填写问卷的患者；',
          checked: false,
        },
        {
          type: '7',
          typeText: '7.	预计麻醉时长小于2h的短小手术（如腹腔镜胆囊切术、短小整形手术）；',
          checked: false,
        },
        {
          type: '8',
          typeText: '8.	3个月内参与其他干预性研究的患者。',
          checked: false,
        }],
      endPeriodForm: {
        checked: false,//自动操作后续失访提交
        list: [{
          type: '1',
          typeText: '受试者死亡',
          checked: false,
          deathDate: '',
          deathCause: '',
          description: ''
        },
        {
          type: '2',
          typeText: '受试者主动退出研究',
          checked: false,
          description: ''
        },
        {
          type: '3',
          typeText: '受试者重新入组，终止本次随访计划',
          checked: false,
          description: ''
        },
        {
          type: '4',
          typeText: '其他原因',
          checked: false,
          description: ''
        }]
      },
      endPeriodList: [],
      projectPeriod: {},
      isPad: this.$route.fullPath.startsWith('/pad'),

      qrCodeVisible: false,
      qrCodeUrl: '',
      selectRowsInfo: {},
      formPushVisible: false,
      formUnPushVisible: false,
      followList: [],
      followPeriodId: undefined,
      followPeriodDate: undefined,
      periodItemId:'',//当前选择的受试者周期id
    }
  },
  mounted() {

    this.loadData()
    getAction('/project/projectPatientField/list', { projectId: this.projectId }).then(res => {
      if (res.success) {
        this.fieldList = res.result
      }
    })
    getAction('/management/project/queryById', { id: this.projectId }).then(res => {
      if (res.success) {
        this.wechat = res.result.wechat
        this.reporting=res.result.reporting
      }
    })
    getAction('/project/projectPeriod/getPeriod', { projectId: this.projectId }).then(res => {
      if (res.success) {
        this.projectPeriod = res.result[0]
      }
    })

    getAction('/project/projectFiltrate/listByCenter', { projectId: this.projectId, type: 3 }).then(res => {
      if (res.success) {
        if (res.result != null && res.result.length > 0) {
          this.endPeriodForm.list = []
          res.result.forEach(item => {
            this.endPeriodForm.list.push({
              type: 4,// 自定义的终止随访原因，暂时都归类到其他原因
              typeText: item.description,
              checked: false,
              description: '',
              remarkFlag: item.remarkFlag
            })
          })
        }
      }
    })
  },
  computed: {
    formProgress() {
      const rate = ((this.patientPeriodInfo.formSubmitCount || 0) / (this.patientPeriodInfo.formCount || 100)) * 100
      return parseFloat(rate.toFixed(2))
    }
  },
  methods: {
    generatePDF() {
      // 获取标题和表格元素
      const titleElement = document.getElementById('table-title');
      const tableElement = document.getElementById('table-content');
      const tableEnd = document.getElementById('table-end');

      // 创建一个包含标题和表格的容器
      const container = document.createElement('div');
      container.appendChild(titleElement.cloneNode(true));  // 复制标题元素
      container.appendChild(tableElement.cloneNode(true));  // 复制表格元素
      container.appendChild(tableEnd.cloneNode(true));  // 复制表格元素
      html2pdf()
        .from(container)
        .set({
          margin: 10,
          filename: 'report.pdf',
          html2canvas: { scale: 2 },  // 更高的缩放比例以提高图像质量
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        })
        .save('report.pdf');  // 保存为 PDF 文件
    },


    chunkedData() {
      this.loading = true

      getAction('/patient/patientFormItem/queryReportById', { patientId: this.patient.id, periodItemId: this.periodItemId }).then(res => {
        if (res.success) {
          const result = [];
          this.reportData = res.result
          for (let i = 0; i < this.reportData.forms.length; i += 2) {
            result.push(this.reportData.forms.slice(i, i + 2));
          }
          this.data = result
        } else {
          this.reportData = {}
          this.data = []
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    currentPeriodId(periodItemId){
      console.log("-----currentPeriodId:"+ periodItemId)
      this.periodItemId=periodItemId
    },
    loadTableData() {
      this.$refs.period.loadTableData()
    },
    handleQrCodeClose() {
      this.qrCodeCancel()
    },
    reloadQrCode() {
      this.loading = true

      getAction('/wechat/getTicket', { patientId: this.patient.id }).then(res => {
        if (res.success) {
          this.qrCodeUrl = res.result
          this.qrCodeVisible = true
        } else {
          return this.$message.error(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    wechatBinding() {
      this.reloadQrCode()
    },
    wechatPush(){
      this.$confirm({
          title: '微信推文',
          content: (<div>
            <p>您确定要向受试者推送微信消息吗？</p>            
          </div>),
          centered: false,
          onOk: () => {
            this.loading = true
            getAction('/patient/patient/noteReport',{patientId: this.patient.id}).then(res=>{
              if(res.success){
                this.$message.info("已发起推送")
              }else {
                this.$message.warning(res.message);
              }
            }).finally(()=>{
              this.loading = false
            })            
          },
        })
    },
    qrCodeCancel() {
      this.qrCodeVisible = false
      this.loadData()
    },
    handleWechatMenuClick(e) {
      switch (e.key) {
        case '1':
          this.pushWechat()
          break
        case '2':
          this.unPushWechat()
          break
        case '3':
          this.unsubscribe()
          break
      }
    },
    formPushCancel() {
      this.formPushVisible = false
      this.formUnPushVisible = false
      this.selectRowsInfo = {}
    },
    pushWechat() {
      this.selectRowsInfo = this.$refs.period.getSelectRowsInfo()
      if (!this.selectRowsInfo.selectionRows.length) {
        return this.$message.error('请选择表单！')
      }
      this.formPushVisible = true
    },
    pushWechatSubmit() {
      let formIds = this.selectRowsInfo.selectedRowKeys.toString()
      this.loading = true
      postAction('/wechat/pushWechat', { formIds: formIds, projectId: this.projectId }).then(res => {
        this.loadTableData()
        this.formPushCancel()
        if (res.success) {
          return this.$message.success(res.message)
        } else {
          return this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    unPushWechat() {
      this.selectRowsInfo = this.$refs.period.getSelectRowsInfo()
      if (!this.selectRowsInfo.selectionRows.length) {
        return this.$message.error('请选择表单！')
      }
      this.formUnPushVisible = true
    },
    unPushWechatSubmit() {
      let formIds = this.selectRowsInfo.selectedRowKeys.toString()
      this.loading = true
      postAction('/wechat/unPushWechat', { formIds: formIds }).then(res => {
        if (res.success) {
          this.loadTableData()
          this.formPushCancel()
          return this.$message.success(res.message)
        } else {
          return this.$message.error(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    unsubscribe() {
      var that = this
      this.$confirm({
        title: '解除微信绑定',
        content: (<div>
          <p>您确定要解除微信绑定吗？</p>
          <p style="color:red;">注意：解除微信绑定后需要重新绑定才能推送表单，请谨慎操作！</p>
        </div>),
        centered: false,
        onOk: () => {
          that.loading = true
          postAction('/patient/patient/unsubscribe', { id: that.patient.id }).then(res => {
            if (res.success) {
              that.loadData()
              return that.$message.success(res.message)
            } else {
              return that.$message.error(res.message)
            }
          }).finally(() => {
            that.loading = false
          })
        },
      })
    },
    loadPatient() {
      getAction('/patient/patient/queryById', { id: this.$route.params.id }).then(res => {
        if (res.success) {
          this.patient = res.result || {}
          this.emptyDescription = '找不到对应数据'
        }
      })
      getAction('/patient/patient/queryInfoById', { id: this.$route.params.id }).then(res => {
        if (res.success) {
          this.patientPeriodInfo = res.result || {}
        }
      })
    },
    loadData() {
      this.loadPatient()
      getAction('/patient/patientEndPeriod/list', { patientId: this.$route.params.id }).then(res => {
        if (res.success) {
          this.endPeriodList = res.result
        }
      })
    },
    loadFollowData() {
      getAction('/patient/patientPeriodItem/list', { patientId: this.patient.id }).then(res => {
        if (res.success) {
          this.followList = res.result
          this.followPeriodId = undefined
          this.followPeriodDate = undefined

          if (this.followList.length > 0) {
            let tempFollowList = this.followList.filter(item => item.base != '1')
            if (tempFollowList != null && tempFollowList.length > 0) {
              this.followPeriodId = tempFollowList[0].id
              this.followPeriodDate = tempFollowList[0].startDate
            }
          }
        }
      })
    },
    followPeriodChange() {
      // console.log("followPeriodId:"+this.followPeriodId)
      if (this.followPeriodId) {
        let tempFollow = this.followList.find(item => item.id == this.followPeriodId)
        this.followPeriodDate = tempFollow.startDate
      }
    },
    handleMenuClick(e) {
      switch (e.key) {
        case '1':
          this.updateBaseDateHandle()
          break
        case '2':
          this.exportHandle()
          break
        case '3':
          this.patientFailHandle()
          break
        case '4':
          this.patientEndPeriodHandle()
          break
        case '5':
          this.handleDelete()
          break
        case '6':
          this.handleRecover()
          break
        case '7':
          this.handleAddPeriod()
          break
        case '8':
          this.$refs.addPeriodFormModal.add();
          break
        case '9':
          this.patientReportHandle()
          break
        case '11':
          this.patientRCTFilterHandle()
          break
        case '12':
          this.patientRCTInterfereHandle()
          break
      }
    },
    /**
     * 修改基点日期
     */
    updateBaseDateHandle() {
      this.baseDateView = true
      this.loadFollowData()
    },
    /**
     * 导出表单
     */
    exportHandle() {

    },
    /**
     * 终止随访
     */
    patientEndPeriodHandle() {
      this.endPeriodVisible = true
    },

    //查看报告
    patientReportHandle() {
      this.chunkedData()
      this.reportVisible = true
    },
    //rct入组
    patientRCTFilterHandle() {
      this.rctFilterVisible = true
      if(this.patient.rctConfig!=null){
        this.rctFilterForm=JSON.parse(this.patient.rctConfig).rctCheck.checkList
        this.patientRCTConfig=JSON.parse(this.patient.rctConfig)
      }
    },
    //rct干预
    patientRCTInterfereHandle(){
      this.rctInterfereVisible=true
      if(this.patient.rctConfig!=null){
        this.patientRCTConfig=JSON.parse(this.patient.rctConfig)
      }
    },

    //RCT入组
    handleRctFilterOk() {
      if(this.patient.rctStatus==='2'){
        this.rctFilterVisible=false
        return
      }
      //全部不勾选则入组随机对照系统
      let isRct=true
      for(const item of this.rctFilterForm){
        if(item.checked) {
          isRct=false
          break
       }
      }
      this.patientRCTConfig.rctGroup='A组'
      this.patientRCTConfig.rctCheck={isRct:isRct,checkList:this.rctFilterForm}
      const patinentRCT = {
        id: this.patient.id,
        isRCT: isRct,
        projectId:this.patient.projectId,
        rctConfig: JSON.stringify(this.patientRCTConfig)
      }
     
      this.loading = true
      postAction('/patient/patient/rctFilter', patinentRCT).then(res => {
        if (res.success) {
          this.loadData()
          this.rctFilterVisible=false
        }
      }).finally(() => {
        this.loading = false
      })
    },
    //RCT干预
    handleRctInterfereOk() {
      const patinentRCT = {
        id: this.patient.id,
        rctConfig: JSON.stringify(this.patientRCTConfig)
      }
     
      this.loading = true
      postAction('/patient/patient/rctInterfere', patinentRCT).then(res => {
        if (res.success) {
          this.loadData()
          this.rctInterfereVisible=false
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleReportingOk(){
      this.reportVisible=false
    },
    handleEndPeriodOk() {
      const form = {
        id: this.patient.id,
        autoLost: this.endPeriodForm.checked,
        list: []
      }
      this.endPeriodForm.list.forEach(item => {
        if (item.checked) {
          form.list.push(item)
        }
      })
      if (form.list.length === 0) {
        return this.$message.error('请填写理由')
      }
      this.loading = true
      postAction('/patient/patient/endPeriod', form).then(res => {
        if (res.success) {
          this.endPeriodVisible = false
          this.loadData()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    checkBoxChange(e, item) {
      const checked = e.target.checked
      item.checked = checked
    },

    /**
     * 恢复随访
     */
    handleRecover() {
      postAction('/patient/patient/recover', { id: this.patient.id }).then(res => {
        if (res.success) {
          this.loadData()
        }
      }).finally(() => {
        this.loading = false
      })
    },

    /**
     * 添加手动随访周期
     */
    handleAddPeriod() {
      this.$refs.period.handleAddPeriod()
    },
    patientFailHandle() {
      this.$refs['failFiltrateModal'].view()
    },
    handleUpdateBaseDateOk() {
      let periodItemList = []
      // console.log(this.followPeriodIds)
      if (!this.followPeriodId || !this.followPeriodDate) {
        return
      }
      let tempFollow = this.followList.find(item => item.id == this.followPeriodId)
      if (tempFollow.base != '1' && tempFollow.groupId) {
        this.followList.forEach(period => {
          if (tempFollow.sortNum <= period.sortNum && tempFollow.groupId === period.groupId) {
            periodItemList.push(period)
          }
        })
      } else {
        this.followList.forEach(period => {
          if (tempFollow.sortNum <= period.sortNum) {
            periodItemList.push(period)
          }
        })
      }
      postAction('/patient/patient/updateBaseDate', { id: this.patient.id, baseDate: this.followPeriodDate, periodItemList: periodItemList }).then(res => {
        if (res.success) {
          this.baseDateView = false
          this.$message.success(res.message)
          if (this.$refs.period) {
            this.$refs.period.loadData()
          }
        }
      })
    },
    handleDeleteOk() {
      deleteAction('/patient/patient/delete', { id: this.patient.id, delReason: this.patient.delReason }).then(res => {
        if (res.success) {
          this.closeCurrent()
          this.$router.push({ path: '/project/patient/register' })
        } else {
          this.$message.warning(res.message || '删除失败')
        }
      })
    },
    handleDelete() {
      const that = this
      this.$confirm({
        title: '提示',
        content: '确认删除吗 ?',
        onOk() {
          that.deleteView = true
        },
        onCancel() {
        },
      });

    },
    handleView() {
      this.$refs['patient-edit'].view(this.patient)
    },
    changeCenterInfo() {
      this.changeCenterInfoModel = {
        personId: this.patient.personId,
        centerId: this.patient.centerId,
        id: this.patient.id
      }
      if (this.centerList.length === 0) {
        getAction('/project/center/listAll', { projectId: this.patient.projectId }).then(res => {
          if (res.success) {
            this.centerList = res.result
            this.changeView = true
          }
        })
        this.loadUserList()
      }
      else {
        this.changeView = true
      }
    },
    loadUserList() {
      getAction('/project/projectUser/listAll', { projectId: this.patient.projectId, centerId: this.patient.centerId }).then(res => {
        if (res.success) {
          this.userList = res.result
        }
      })
    },
    handleChangeCenterOk() {
      if (this.patient.centerId === this.changeCenterInfoModel.centerId && this.changeCenterInfoModel.personId === this.patient.personId) {
        return this.$message.warning('研究人员未变更，请重新选择')
      }
      postAction('/patient/patient/editCenterInfo', this.changeCenterInfoModel).then(res => {
        if (res.success) {
          this.changeView = false
          this.loadData()
        }
      })
    },
    changeHistory() {
      getAction('/patient/patientCenterInfoHistory/list', { patientId: this.patient.id }).then(res => {
        if (res.success) {
          this.historyList = res.result
          this.changeHistoryView = true
        }
      })
    },
    modelClose() {
      if (this.$refs.period) {
        this.$refs.period.loadData()
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filterOptionTip(input, option) {
      return option.componentOptions.children[0].componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  }
}
</script>

<style scoped lang="less">
.report-container {
  font-family: Arial, sans-serif;
  margin: 20px;
}

.report-header {
  text-align: center;
}

.report-title {
  font-size: 24px;
  margin-bottom: 20px;
}

.report-body {
  // border: 1px solid #ccc;
  padding: 10px 0;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
}

.report-cell {
  border: 1px solid #ccc;
  padding: 5px;
  text-align: left;
}

.report-cell:first-child {
  width: 50%;
}

.register-view {
  overflow: hidden;
  padding: 10px;

  .view-panel {
    border: 1px solid rgba(0, 0, 0, 0.2);
    overflow-y: auto;
    padding: 10px;
    height: calc(100vh - 150px);
  }

  .view-panel-pad {
    height: calc(100vh - 75px) !important;
  }

  .view-panel1 {
    width: 20%;
    float: left;
  }

  .view-panel2 {
    margin-left: 20px;
    float: left;
    width: calc(80% - 20px);
  }

  .view-panel2-pad {
    width: calc(100% - 1px);
    margin-left: 0px;

  }

  .info1 {
    font-weight: bold;
    font-size: 16px;
  }

  .info2 {
    font-size: 16px;
    margin-top: 15px;
    text-align: left;
  }

  .info-row {
    margin-top: 10px;
  }
  .research-info-bar {
  display: flex;
  align-items: center;
  justify-content: center;    /* 让内容居中 */
  position: relative;
  height: 40px;               /* 可根据需要调整高度 */
}

.research-title {
  font-weight: bold;
  font-size: 16px;
}

.research-actions {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  height: 100%;
}

  .info-row2 {
    margin-top: 20px;
  }

  .progress {
    font-size: 16px;
  }

  .value-info {
    font-size: 18px;
    font-weight: bold;
  }

  .filtrate-fail {
    border: 0.5px solid rgba(221, 51, 55, 0.5);
    margin-top: 10px;
    padding: 10px;
    background-color: #FFF1F0;

    .fail-title {
      font-size: 16px;
    }

    .fail-info {
      margin-left: 20px;
    }
  }

}

.pad-card {
  margin: 5px;
}
</style>